import { BookingStatus } from "types/booking";

/** Bookings not yet validated/cancelled may be auto-validated 48h after the intervention. */
export const isAutoValidatableStatus = (status: BookingStatus): boolean =>
    status === BookingStatus.PENDING
    || status === BookingStatus.IN_PROGRESS
    || status === BookingStatus.TO_VALIDATE;

export const getStatusLabelId = (status: BookingStatus): string | null => {
    if (status === BookingStatus.CANCELLED) {
        return "profile.service_history.cancelled";
    }

    if (status === BookingStatus.PENDING) {
        return "profile.service_history.pending";
    }

    if (status === BookingStatus.IN_PROGRESS) {
        return "profile.service_history.in_progress";
    }

    if (status === BookingStatus.TO_VALIDATE) {
        return "profile.service_history.to_validate";
    }

    return null;
};

export const getStatusBadgeClassName = (status: BookingStatus): string => {
    if (status === BookingStatus.CANCELLED) {
        return "border-red-200 bg-red-50 text-red-700";
    }

    if (status === BookingStatus.TO_VALIDATE) {
        return "border-amber-200 bg-amber-50 text-amber-700";
    }

    if (status === BookingStatus.PENDING) {
        return "border-slate-200 bg-slate-50 text-slate-700";
    }

    if (status === BookingStatus.IN_PROGRESS) {
        return "border-emerald-200 bg-emerald-50 text-emerald-700";
    }

    return "border-emerald-200 bg-emerald-50 text-emerald-700";
};
